export default {
  OPEN: "open",
  Rr: "purchase",
  vr: "push_click",
  be: "custom_event",
  Mr: "iam_click",
  ks: "test"
};
